import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { Game, GamesService, PopUpService, ModalComponent, UtilsService, ClientsService, Client } from 'core/index';
import { switchMap } from 'rxjs/operators';
import { MatTabGroup } from '@angular/material/tabs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lms-game-detail',
  templateUrl: './game-detail.component.html',
  styleUrls: ['./game-detail.component.scss']
})
export class GameDetailComponent implements OnInit, OnDestroy {
  public game: Game;
  public client: Client;
  public currentTab = 'data';
  public modal: ModalComponent;
  public filters: Map<string, string>;
  public tabsManager: any | Subscription = new Subscription();
  public studentsSortingFields = [
    { field: 'name', label: 'students.sortableFields.name' },
    { field: 'email', label: 'students.sortableFields.email' }
  ];
  @ViewChild('tabGroup', { static: false }) public tabGroup: MatTabGroup;

  constructor(
    public gamesService: GamesService,
    public route: ActivatedRoute,
    public location: Location,
    public router: Router,
    public utilsService: UtilsService,
    public popupService: PopUpService,
    public clientsService: ClientsService
  ) {}

  public ngOnInit(): void {
    this.route.paramMap
      .pipe(switchMap((params: ParamMap) => this.gamesService.getGame(params.get('id'))))
      .subscribe((game) => {
        this.clientsService.getClient(game.clientId).subscribe((client) => {
          this.game = game;
          this.client = client;

          this.filters = new Map<string, string>().set('gameId', game.id);
          this.loadTabManager();
        });
      });
  }

  private loadTabManager(): void {
    setTimeout(() => {
      this.tabsManager = UtilsService.createTabsManager(this.route, this.tabGroup);
    }, 0);
  }

  public ngOnDestroy(): void {
    this.tabsManager.unsubscribe();
  }

  public goBack(): void {
    this.location.back();
  }

  public onUpdateGame(game: Game): void {
    this.game = game;
  }
}
